module.exports = __webpack_public_path__ + "static/media/hownottobewrong.e47be17b.avif";